export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#065F46] to-[#047857] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-[#10B981] rounded-full">
                <i className="ri-heart-pulse-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold" style={{ fontFamily: "'Noto Serif JP', serif" }}>アスロン整体</h3>
              </div>
            </div>
            <p className="text-sm text-white/80 leading-relaxed">
              理学療法士の知識と整体の技術を融合し、<br />
              痛みの根本原因にアプローチする訪問整体サービスです。
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">サイトマップ</h4>
            <ul className="space-y-3">
              {[
                { id: 'about', label: 'お悩み' },
                { id: 'services', label: '施術の特徴' },
                { id: 'flow', label: '整体の流れ' },
                { id: 'pricing', label: '料金' },
                { id: 'contact', label: 'お問い合わせ' },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-sm text-white/80 hover:text-[#6EE7B7] transition-colors cursor-pointer"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">お問い合わせ</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-phone-line text-xl text-[#6EE7B7] mt-1"></i>
                <div>
                  <p className="text-sm text-white/60 mb-1">電話番号</p>
                  <a href="tel:09018959421" className="text-base font-medium hover:text-[#6EE7B7] transition-colors cursor-pointer">
                    090-1895-9421
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-xl text-[#6EE7B7] mt-1"></i>
                <div>
                  <p className="text-sm text-white/60 mb-1">メール</p>
                  <a 
                    href="mailto:athlon.4448@gmail.com" 
                    className="text-sm font-medium hover:text-[#6EE7B7] transition-colors cursor-pointer break-all"
                  >
                    athlon.4448@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-line-fill text-xl text-[#6EE7B7] mt-1"></i>
                <div>
                  <p className="text-sm text-white/60 mb-1">公式LINE</p>
                  <a 
                    href="https://lin.ee/uGMpYkR" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-base font-medium hover:text-[#6EE7B7] transition-colors cursor-pointer"
                  >
                    LINEで相談する
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-time-line text-xl text-[#6EE7B7] mt-1"></i>
                <div>
                  <p className="text-sm text-white/60 mb-1">営業時間</p>
                  <p className="text-base">10:00〜18:00（応相談）</p>
                  <p className="text-sm text-white/70 mt-0.5">定休日：日曜日</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl text-[#6EE7B7] mt-1"></i>
                <div>
                  <p className="text-sm text-white/60 mb-1">対応エリア</p>
                  <p className="text-base leading-relaxed">
                    大阪市北部・吹田市・豊中市<br />
                    <span className="text-sm text-white/70">※周辺エリアもご相談ください</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <p className="text-center text-sm text-white/60">
            © 2024 アスロン整体. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}